// extracted by mini-css-extract-plugin
export var billingAddress = "_r0-g";
export var contactInfo = "_r0-d";
export var customerInfoContainer = "_r0-c";
export var customerInfoContainerMobile = "_r0-h";
export var customerInfoRow = "_r0-a";
export var customerInfoSection = "_r0-b";
export var fullWidthDividerMobile = "_r0-i";
export var imageContainer = "_r0-1";
export var paymentMethod = "_r0-e";
export var priceText = "_r0-6";
export var priceTextMobile = "_r0-7";
export var product = "_r0-0";
export var productImage = "_r0-2";
export var productInfo = "_r0-4";
export var productMobile = "_r0-9";
export var productTitle = "_r0-8";
export var quantityBadge = "_r0-3";
export var quantityText = "_r0-5";
export var shippingAddress = "_r0-f";